module.exports = __webpack_public_path__ + "static/img/son7_active.52b94bd0.png";